// Generated by Melange

import * as Buhta_kassaapis__Buhta_kassa_v1_types from "../../../../proto/kassaapis/gen/buhta_kassa_v1_types.js";
import * as StaticAsset from "../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const include = Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType;

function toString(param) {
  switch (param) {
    case /* OPERATION_TYPE_UNSPECIFIED */0 :
        return "Көрсетілмеген/Не указано";
    case /* OPERATION_TYPE_SALE */1 :
        return "Сату/Продажа";
    case /* OPERATION_TYPE_SALE_RETURN */2 :
        return "Қайтару/Возврат";
    case /* OPERATION_TYPE_PURCHASE */3 :
        return "Сатып алу/Покупка";
    case /* OPERATION_TYPE_PURCHASE_RETURN */4 :
        return "Сатып алуды қайтару/Возврат покупки";
    
  }
}

function toStringRu(param) {
  switch (param) {
    case /* OPERATION_TYPE_UNSPECIFIED */0 :
        return "Не указано";
    case /* OPERATION_TYPE_SALE */1 :
        return "Продажа";
    case /* OPERATION_TYPE_SALE_RETURN */2 :
        return "Возврат";
    case /* OPERATION_TYPE_PURCHASE */3 :
        return "Покупка";
    case /* OPERATION_TYPE_PURCHASE_RETURN */4 :
        return "Возврат покупки";
    
  }
}

function toStringPlural(param) {
  switch (param) {
    case /* OPERATION_TYPE_UNSPECIFIED */0 :
        return "Көрсетілмеген/Не указано";
    case /* OPERATION_TYPE_SALE */1 :
        return "Сату/Продажи";
    case /* OPERATION_TYPE_SALE_RETURN */2 :
        return "Қайтару/Возвраты";
    case /* OPERATION_TYPE_PURCHASE */3 :
        return "Сатып алу/Покупки";
    case /* OPERATION_TYPE_PURCHASE_RETURN */4 :
        return "Сатып алуды қайтару/Возвраты покупки";
    
  }
}

const OperationType_name = include.name;

const OperationType_to_int = include.to_int;

const OperationType_from_int = include.from_int;

const OperationType_from_int_exn = include.from_int_exn;

const OperationType_to_string = include.to_string;

const OperationType_from_string_exn = include.from_string_exn;

const OperationType = {
  name: OperationType_name,
  to_int: OperationType_to_int,
  from_int: OperationType_from_int,
  from_int_exn: OperationType_from_int_exn,
  to_string: OperationType_to_string,
  from_string_exn: OperationType_from_string_exn,
  toString: toString,
  toStringRu: toStringRu,
  toStringPlural: toStringPlural
};

const include$1 = Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType;

function toReact(param) {
  switch (param) {
    case /* PAYMENT_TYPE_UNSPECIFIED */0 :
        return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsx("img", {
                            className: "mr-2 w-5 h-5",
                            src: StaticAsset.src("/static/icons/mixed.svg")
                          }),
                      "Смешанная"
                    ]
                  });
    case /* PAYMENT_TYPE_CASH */1 :
        return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsx("img", {
                            className: "mr-2 w-5 h-5",
                            src: StaticAsset.src("/static/icons/cash-20.svg")
                          }),
                      "Наличными"
                    ]
                  });
    case /* PAYMENT_TYPE_CARD */2 :
        return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsx("img", {
                            className: "mr-2 w-5 h-5",
                            src: StaticAsset.src("/static/icons/card-black-20.svg")
                          }),
                      "Картой"
                    ]
                  });
    case /* PAYMENT_TYPE_CREDIT */3 :
    case /* PAYMENT_TYPE_TARE */4 :
        return "Неверный тип";
    case /* PAYMENT_TYPE_MOBILE */5 :
        return "Приложением";
    
  }
}

function toString$1(param) {
  switch (param) {
    case /* PAYMENT_TYPE_UNSPECIFIED */0 :
        return "Аралас/Смешанная";
    case /* PAYMENT_TYPE_CASH */1 :
        return "Қолма-қол ақша/Наличные";
    case /* PAYMENT_TYPE_CARD */2 :
        return "Карта";
    case /* PAYMENT_TYPE_CREDIT */3 :
    case /* PAYMENT_TYPE_TARE */4 :
        return "Қате түр/Неверный тип";
    case /* PAYMENT_TYPE_MOBILE */5 :
        return "Қолданба/Приложение";
    
  }
}

const PaymentType_name = include$1.name;

const PaymentType_to_int = include$1.to_int;

const PaymentType_from_int = include$1.from_int;

const PaymentType_from_int_exn = include$1.from_int_exn;

const PaymentType_to_string = include$1.to_string;

const PaymentType_from_string_exn = include$1.from_string_exn;

const PaymentType = {
  name: PaymentType_name,
  to_int: PaymentType_to_int,
  from_int: PaymentType_from_int,
  from_int_exn: PaymentType_from_int_exn,
  to_string: PaymentType_to_string,
  from_string_exn: PaymentType_from_string_exn,
  toReact: toReact,
  toString: toString$1
};

function toString$2(param) {
  switch (param) {
    case 0 :
        return "";
    case 1 :
        return "ОФД Бухта";
    case 2 :
        return "АО \"Казахтелеком\"";
    case 3 :
        return "АО \"Транстелеком\"";
    default:
      return "Неизвестно";
  }
}

const Provider = {
  toString: toString$2
};

const include$2 = Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType;

function toString$3(param) {
  if (param) {
    return "ҚҚС/НДС";
  } else {
    return "Көрсетілмеген/Не указано";
  }
}

const TaxType_name = include$2.name;

const TaxType_to_int = include$2.to_int;

const TaxType_from_int = include$2.from_int;

const TaxType_from_int_exn = include$2.from_int_exn;

const TaxType_to_string = include$2.to_string;

const TaxType_from_string_exn = include$2.from_string_exn;

const TaxType = {
  name: TaxType_name,
  to_int: TaxType_to_int,
  from_int: TaxType_from_int,
  from_int_exn: TaxType_from_int_exn,
  to_string: TaxType_to_string,
  from_string_exn: TaxType_from_string_exn,
  toString: toString$3
};

const include$3 = Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType;

function toString$4(param) {
  switch (param) {
    case /* DOMAIN_TYPE_UNSPECIFIED */0 :
        return "Не указана";
    case /* DOMAIN_TYPE_TRADING */1 :
        return "Торговля";
    case /* DOMAIN_TYPE_SERVICES */2 :
        return "Услуги";
    case /* DOMAIN_TYPE_GASOIL */3 :
        return "Нефть и газ";
    case /* DOMAIN_TYPE_HOTELS */4 :
        return "Отели";
    case /* DOMAIN_TYPE_TAXI */5 :
        return "Такси";
    case /* DOMAIN_TYPE_PARKING */6 :
        return "Паркинг";
    
  }
}

const DomainType_name = include$3.name;

const DomainType_to_int = include$3.to_int;

const DomainType_from_int = include$3.from_int;

const DomainType_from_int_exn = include$3.from_int_exn;

const DomainType_to_string = include$3.to_string;

const DomainType_from_string_exn = include$3.from_string_exn;

const DomainType = {
  name: DomainType_name,
  to_int: DomainType_to_int,
  from_int: DomainType_from_int,
  from_int_exn: DomainType_from_int_exn,
  to_string: DomainType_to_string,
  from_string_exn: DomainType_from_string_exn,
  toString: toString$4
};

function initValue_1(param) {
  
}

const initValue = [
  /* [] */0,
  initValue_1
];

const context = React.createContext(initValue);

function use(param) {
  return React.useContext(context);
}

const make = context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

const Provider$1 = {
  make: make,
  makeProps: makeProps
};

function useKkms(initialKkms) {
  return React.useReducer((function (state, action) {
                if (action.TAG === /* Add */0) {
                  return Stdlib.$at(state, action._0);
                } else {
                  return action._0;
                }
              }), initialKkms);
}

const KkmsCtx = {
  initValue: initValue,
  context: context,
  use: use,
  Provider: Provider$1,
  useKkms: useKkms
};

const include$4 = Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.MoneyPlacementType;

function toString$5(param) {
  switch (param) {
    case /* MONEY_PLACEMENT_TYPE_UNSPECIFIED */0 :
        return "Ошибочная операция с наличными в сумме ";
    case /* MONEY_PLACEMENT_TYPE_DEPOSIT */1 :
        return "Внесено наличных в сумме ";
    case /* MONEY_PLACEMENT_TYPE_WITHDRAWAL */2 :
        return "Снято наличных в сумме ";
    
  }
}

function toStringShort(param) {
  switch (param) {
    case /* MONEY_PLACEMENT_TYPE_UNSPECIFIED */0 :
        return "Ошибочная операция";
    case /* MONEY_PLACEMENT_TYPE_DEPOSIT */1 :
        return "Внесено";
    case /* MONEY_PLACEMENT_TYPE_WITHDRAWAL */2 :
        return "Снято";
    
  }
}

const MoneyPlacementType_name = include$4.name;

const MoneyPlacementType_to_int = include$4.to_int;

const MoneyPlacementType_from_int = include$4.from_int;

const MoneyPlacementType_from_int_exn = include$4.from_int_exn;

const MoneyPlacementType_to_string = include$4.to_string;

const MoneyPlacementType_from_string_exn = include$4.from_string_exn;

const MoneyPlacementType = {
  name: MoneyPlacementType_name,
  to_int: MoneyPlacementType_to_int,
  from_int: MoneyPlacementType_from_int,
  from_int_exn: MoneyPlacementType_from_int_exn,
  to_string: MoneyPlacementType_to_string,
  from_string_exn: MoneyPlacementType_from_string_exn,
  toString: toString$5,
  toStringShort: toStringShort
};

export {
  OperationType ,
  PaymentType ,
  Provider ,
  TaxType ,
  DomainType ,
  KkmsCtx ,
  MoneyPlacementType ,
}
/* context Not a pure module */
